import L from 'leaflet';
import Vue from 'vue';

export default function ControleLeafletComComponenteVue(
    componenteVue,
    mapa,
    props,
    configControle
) {
    const config = { position: 'topright', ...configControle };

    const controle = L.control(config);

    let classeControle = 'leaflet-control leaflet-bar ';
    if (configControle && configControle.classeControle) {
        classeControle += configControle.classeControle;
    }

    controle.onAdd = () => {
        const container = L.DomUtil.create('div', classeControle);

        const ClasseComponenteVue = Vue.extend(componenteVue);
        const instance = new ClasseComponenteVue({
            propsData: { mapa, ...props }
        });

        instance.$mount();
        container.appendChild(instance.$el);

        return container;
    };

    controle.addTo(mapa);
}
